import { Controller } from "@hotwired/stimulus"

// Handles toggling between Table (Tabulator) and PDF view for spreadsheet attachments
export default class extends Controller {
  static targets = ["toggleContainer", "tableView", "pdfView", "pdfViewer", "sheetTabs"]
  static values = { pdfUrl: String, currentView: { type: String, default: "table" } }

  pdfLoaded = false

  connect() {
    // Start with table view active
    this.currentViewValue = "table"
  }

  switchView(event) {
    const viewMode = event.currentTarget.dataset.viewMode
    if (viewMode === this.currentViewValue) return

    this.currentViewValue = viewMode

    // Update toggle button styles
    this.updateToggleButtons(viewMode)

    if (viewMode === "table" || viewMode === "email") {
      this.showTableView()
    } else if (viewMode === "pdf") {
      this.showPdfView()
    }
  }

  updateToggleButtons(activeMode) {
    if (!this.hasToggleContainerTarget) return

    const buttons = this.toggleContainerTarget.querySelectorAll('.view-toggle-btn')
    buttons.forEach(btn => {
      const isActive = btn.dataset.viewMode === activeMode
      btn.classList.toggle('tab-active', isActive)
      btn.setAttribute('aria-pressed', String(isActive))
    })
  }

  showTableView() {
    if (this.hasTableViewTarget) {
      this.tableViewTarget.classList.remove('hidden')
    }
    if (this.hasPdfViewTarget) {
      this.pdfViewTarget.classList.add('hidden')
    }
    // Show sheet tabs when in table view (if they exist)
    if (this.hasSheetTabsTarget) {
      this.sheetTabsTarget.classList.remove('hidden')
    }
  }

  showPdfView() {
    if (this.hasTableViewTarget) {
      this.tableViewTarget.classList.add('hidden')
    }
    if (this.hasPdfViewTarget) {
      this.pdfViewTarget.classList.remove('hidden')
    }
    // Hide sheet tabs when in PDF view (if they exist)
    if (this.hasSheetTabsTarget) {
      this.sheetTabsTarget.classList.add('hidden')
    }

    // Load PDF if not already loaded
    if (!this.pdfLoaded && this.hasPdfUrlValue && this.hasPdfViewerTarget) {
      this.loadPdf()
    }
  }

  loadPdf() {
    // Set the URL on the pdf-viewer controller and trigger it to load
    const pdfViewerElement = this.pdfViewerTarget
    if (pdfViewerElement) {
      // Update the URL value
      pdfViewerElement.dataset.pdfViewerUrlValue = this.pdfUrlValue
      
      // Get the Stimulus controller instance and trigger load
      const pdfController = this.application.getControllerForElementAndIdentifier(
        pdfViewerElement, 
        "pdf-viewer"
      )
      if (pdfController) {
        // Set the value directly on the controller as well
        pdfController.urlValue = this.pdfUrlValue
        if (typeof pdfController.createPdfViewer === 'function') {
          pdfController.createPdfViewer()
        }
      }
      this.pdfLoaded = true
    }
  }
}
